import React from 'react';
import {observer} from 'mobx-react';
import {withState, t} from 'shared/core';
import {TaxableBenefitFlowState} from '../state';
import {Flow} from 'components';
import CoverageRatesForm from './CoverageRatesForm';

const TaxableBenefitFlow = observer(({uiState}) => {
  const {benefitClass, steps, backPath} = uiState;

  return (
    <Flow
      name={benefitClass.fullName}
      backTitle={t('taxable_benefits.Benefit Classes')}
      backRoute={backPath}
      steps={steps}
      component={CoverageRatesForm}
      uiState={uiState}
      baseUrl='/'
      onStepSubmitted={step => uiState.onStepSubmitted(step)}
      onStepChanged={step => uiState.onStepChanged(step)}
    />
  );
});

export default withState(TaxableBenefitFlow, TaxableBenefitFlowState);
